import { useParams } from '@tanstack/react-router';
import SubscribeButton from '../components/subscribe-button';
import BaseScreen from './_base';

export default function SearchDetailScreen() {
  const { tableId } = useParams({ from: '/auth/search/table/$tableId' });

  return (
    <>
      <div className="flex items-center justify-end mb-3">
        <SubscribeButton tableId={tableId} />
      </div>
      <BaseScreen title="Search Detail" description="Search results table." />
    </>
  );
}
